import { sendToApi } from 'api/client'
import { ScheduledPostTarget } from 'types'
import { ExternalIntegrationEnum } from './ExternalIntegrationsClient'

export type { ScheduledPostTarget }

export interface CreateScheduledPostTargetParams {
  scheduled_post_id: number
  provider: ExternalIntegrationEnum
  target_overrides?: Record<string, any>
  external_integration_id?: number
}

export interface UpdateScheduledPostTargetParams {
  target_overrides?: Record<string, any>
  status?: ScheduledPostTarget['status']
}

export const ScheduledPostTargetsClient = {
  create: async ({
    workspaceId,
    scheduledPostId,
    params,
  }: {
    workspaceId: number
    scheduledPostId: number
    params: CreateScheduledPostTargetParams
  }) => {
    const res = await sendToApi<{ scheduled_post_target: ScheduledPostTarget }>(
      `/w/${workspaceId}/scheduled_posts/${scheduledPostId}/scheduled_post_targets`,
      {
        method: 'POST',
        body: params,
      },
    )

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },

  update: async ({
    workspaceId,
    scheduledPostId,
    targetId,
    params,
  }: {
    workspaceId: number
    scheduledPostId: number
    targetId: number
    params: UpdateScheduledPostTargetParams
  }) => {
    const res = await sendToApi<{ scheduled_post_target: ScheduledPostTarget }>(
      `/w/${workspaceId}/scheduled_posts/${scheduledPostId}/scheduled_post_targets/${targetId}`,
      {
        method: 'PUT',
        body: params,
      },
    )

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },

  delete: async ({
    workspaceId,
    scheduledPostId,
    targetId,
  }: {
    workspaceId: number
    scheduledPostId: number
    targetId: number
  }) => {
    const res = await sendToApi<{ scheduled_post_target: ScheduledPostTarget }>(
      `/w/${workspaceId}/scheduled_posts/${scheduledPostId}/scheduled_post_targets/${targetId}`,
      {
        method: 'DELETE',
      },
    )

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },

  show: async ({
    workspaceId,
    scheduledPostId,
    targetId,
  }: {
    workspaceId: number
    scheduledPostId: number
    targetId: number
  }) => {
    return sendToApi<{ scheduled_post_target: ScheduledPostTarget }>(
      `/w/${workspaceId}/scheduled_posts/${scheduledPostId}/scheduled_post_targets/${targetId}`,
    )
  },

  index: async ({ workspaceId, scheduledPostId }: { workspaceId: number; scheduledPostId: number }) => {
    return sendToApi<{ scheduled_post_targets: ScheduledPostTarget[] }>(
      `/w/${workspaceId}/scheduled_posts/${scheduledPostId}/scheduled_post_targets`,
    )
  },

  publish: async ({
    workspaceId,
    scheduledPostId,
    targetIds,
  }: {
    workspaceId: number
    scheduledPostId: number
    targetIds?: number[]
  }) => {
    const res = await sendToApi<{ scheduled_post_targets: ScheduledPostTarget[] }>(
      `/w/${workspaceId}/scheduled_posts/${scheduledPostId}/publish_targets`,
      {
        method: 'POST',
        body: {
          target_ids: targetIds,
        },
      },
    )

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },
}
